/* ==========================================================================
   jays-pdp-reveal.js — "new chapter" colour reveal for the editorial block on
   the product page (The Story · The Details · In the Box / Key Features).
   Added 2026-10-03.

   WHAT IT DOES
   The three sections carry the class `pdp-reveal`. In CSS (jays-pdp.css,
   "Chapter reveal") they start off-white with charcoal text. When the reader
   scrolls the first of them up to the top part of the window, this script adds
   `is-dark` to all three at once and CSS animates them to the site's dark
   palette. One-shot: once dark they stay dark for the rest of the visit.

   WHY A SCRIPT
   CSS alone cannot know when an element reaches the top of the fold. The
   IntersectionObserver below fires once the first section's top edge crosses a
   line 45% down the viewport (rootMargin trims the bottom 55% of the window).

   SAFETY
   - No JS, or reduced-motion: CSS shows the sections dark from the start.
   - If the sections are already above that line on load (deep link, back
     button), they flip immediately so nobody is stuck on the light state.
   ========================================================================== */
(() => {
  'use strict';

  const sections = Array.from(document.querySelectorAll('.pdp-reveal'));
  if (!sections.length) return;

  const reveal = () => sections.forEach((el) => el.classList.add('is-dark'));

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    reveal();
    return;
  }

  const first = sections[0];

  // Already scrolled past the trigger line? Flip now.
  if (first.getBoundingClientRect().top < window.innerHeight * 0.45) {
    reveal();
    return;
  }

  const io = new IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting)) {
      reveal();
      io.disconnect();
    }
  }, { rootMargin: '0px 0px -55% 0px', threshold: 0 });

  io.observe(first);
})();
